module.exports = __webpack_public_path__ + "img/girl.8777826e.png";